import { useQuery } from "@tanstack/react-query";
import { qk } from "../../lib/queryKeys";
import { getJson } from "../../lib/http";
import { useCompaniesStore } from "../../store/admin/companiesStore";
import type { Session } from "../../store/admin/sessionsStore";

export interface SessionListParams {
  page?: number;
  limit?: number;
  active?: string;
  platform?: string;
  search?: string;
}

interface ListMeta {
  error: string | null;
  count: number;
  status: number;
  currentPage: number;
  totalPages: number;
  totalItems: number;
  url: string;
}

interface SessionListBody {
  data?: Session[];
  meta?: ListMeta;
}

export interface SessionListResult {
  data: Session[];
  meta?: ListMeta;
}

function normalize(body: SessionListBody): SessionListResult {
  const data = (body.data ?? []).map((session) =>
    session.active && session.endedAt ? { ...session, active: false } : session,
  );
  return { data, meta: body.meta };
}

export function useSessionsList(params: SessionListParams = {}) {
  const companyId = useCompaniesStore((s) => s.companyId);
  return useQuery({
    queryKey: qk.sessions.list(companyId, params),
    queryFn: ({ signal }) =>
      getJson<SessionListBody>(
        "/sessionList",
        { page: 1, limit: 9, ...params },
        { signal },
      ).then(normalize),
  });
}
